import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { AppEventDispatcher } from './../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../shared/EventTypes';
import { DepositEventType } from './../deposit-per-ticket.event.type';
import { TweenMax, Quint } from 'gsap';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import * as moment from 'moment';
import { ModalErrorEventType } from '../../../shared/modal-error/modal-error.event.type';
import { Deposit } from '../models/deposit';
import { DepositPerTicketService } from '../deposit-per-ticket.service';
import { query } from '@angular/animations';
import { ListItem } from '../../../shared/list-confirmation/model/list-item';
import { FormatPricePipe } from '../../../shared/format-price.pipe';
import { CurrencyPipe } from '@angular/common';

@Component({
	selector: 'app-deposit-data',
	templateUrl: './deposit-data.component.html',
	styleUrls: ['./deposit-data.component.styl'],
	encapsulation: ViewEncapsulation.None,
	providers: [CurrencyPipe]
})
export class DepositDataComponent implements OnInit, OnDestroy {

	@Input() flow: string;
	@Input() submited = false;
	@Input() depositData: Deposit;
	@Output() formInvalid: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() setForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

	private view = '[data-component="deposit-data"]';
	active = false;
	private viewHeight = 0;

	public form: FormGroup;
	public limitsDeposit: any = {}

	constructor(
		private formBuilder: FormBuilder,
		private depositPerTicketService: DepositPerTicketService,
		private currencyPipe: CurrencyPipe
	) {
		this.form = formBuilder.group({
			'value': [null, []]
		});
	}

	ngOnInit() {
		AppEventDispatcher.listen(
			DepositEventType.STEPS.DEPOSIT_DATA,
			data => {
				if (data.show) {
					this.active = true;
					this.setForm.emit(this.form);
					this.show();
				} else {
					this.hide();
				}
			}
		);

		AppEventDispatcher.listen(DepositEventType.SEND.DEPOSIT_DATA_SEND, () => {
			this.hide();
		});

		AppEventDispatcher.listen(ModalErrorEventType.MODAL.CANCEL, data => {
			AppEventDispatcher.dispatch(EventTypes.MODAL_ERROR.MODAL_CLOSE, {  });
		});

		AppEventDispatcher.listen(ModalErrorEventType.MODAL.OK, data => {
			AppEventDispatcher.dispatch(EventTypes.MODAL_ERROR.MODAL_CLOSE, {  });
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(DepositEventType.STEPS.DEPOSIT_DATA);
		AppEventDispatcher.removeListener(DepositEventType.SEND.DEPOSIT_DATA_SEND);
		AppEventDispatcher.removeListener(ModalErrorEventType.MODAL.CANCEL);
		AppEventDispatcher.removeListener(ModalErrorEventType.MODAL.OK);
	}

	show() {
		this.getLimitsDeposit();

		const interval = setInterval(() => {
			if ($(this.view).length > 0) {
				const containerHeight = this.getStepHeight() - 72;

				this.viewHeight = containerHeight;

				TweenMax.to('.steps-container', 0.8, {
					height: containerHeight,
					ease: Quint.easeOut
				});
				TweenMax.to(this.view, 0.8, {
					delay: 0.4,
					left: 0,
					ease: Quint.easeOut
				});
				TweenMax.to('.buttons', 0.8, {
					delay: 0.8,
					bottom: 0,
					ease: Quint.easeOut
				});

					if ($('.currency-field').val() === '0,00' || $('.currency-field').val() === '0,') {
						$('.currency-field').val('');
					}

				clearInterval(interval);
			}
		}, 10);
	}

	hide() {
		this.depositData.value = this.form.controls.value.value;

		this.preload(true);
		this.submited = false;

		let time = 1;
		const timeLoader = setInterval(() => {
			time++;
		}, 1000);

		this.readySend(timeLoader, time);
	}

	readySend(timeLoader, time) {

		this.preload(true);

		this.depositPerTicketService.getTicket(this.depositData.value).subscribe(data => {

			this.depositData.success = data.Sucesso;
			this.depositData.message = "Boleto gerado com sucesso!"

			this.depositData.generatedIn = moment(data.Retorno.DtGerado).format('DD/MM/YYYY');
			this.depositData.payeeName = data.Retorno.NomeTitular;
			this.depositData.value = data.Retorno.Valor;
			this.depositData.maturity = moment(data.Retorno.DtVcto).format('DD/MM/YYYY');
			this.depositData.digitableLine = data.Retorno.LinhaDigitavel;
			this.depositData.numberBankSlip = data.Retorno.NroTitulo;

			this.buildResumeList();

			if (time > 3) {
				this.preload(false);
				this.hideAfterSend();
			} else {
				TweenMax.delayedCall(3 - time, () => {
					this.preload(false, 3 - time);
					this.hideAfterSend();
				});
			}
			clearInterval(timeLoader);

		}, error => {

			AppEventDispatcher.dispatch(DepositEventType.ERROR, { step: DepositEventType.STEPS.DEPOSIT_DATA });

			if (time > 3) {
				this.preload(false);
				this.setForm.emit(this.form);
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			} else {
				TweenMax.delayedCall(3 - time, () => {
					this.preload(false, 3 - time);
					this.setForm.emit(this.form);
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
				});
			}
			clearInterval(timeLoader);


		});
	}

	buildResumeList() {

		const resumeList = [];

		resumeList.push(new ListItem('Boleto gerado em:', this.depositData.generatedIn));
		resumeList.push(new ListItem('Nome do favorecido:', this.depositData.payeeName, 'cls_mask'));
		const FP = new FormatPricePipe();
		resumeList.push(new ListItem('Valor:', FP.transform(this.depositData.value, false), 'cls_mask'));
		resumeList.push(new ListItem('Vencimento:', this.depositData.maturity));
		resumeList.push(new ListItem('Linha Digitável:', this.depositData.digitableLine, 'cls_mask'));
		resumeList.push(new ListItem('Valor disponível em sua conta:', 'Até 02 dias após o pagamento'));

		this.depositData.resumeList = resumeList;
	}

	hideAfterSend() {

		AppEventDispatcher.dispatch(DepositEventType.STEPS.DEPOSIT_RESULT, { show: true });

		TweenMax.to(this.view, .8, {
			left: '-100%', ease: Quint.easeOut, onComplete: () => {
				this.active = false;
			}
		});

	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

	verifyZero() {
		if ($('.currency-field').val() === '0,00') {
			$('.currency-field').val('');
		}
	}

	addValue(value) {
		const newValue = this.form.controls.value.value + value;
		this.form.controls.value.setValue(newValue);
	}

	formatToCurrency(value: number): string {
    return this.currencyPipe.transform(value, 'BRL', 'symbol', '1.2-2');
  }

	renderValueMessage = (
		ValorMinimoPorTransacao: number,
		ValorMaximoPorTransacao: number,
		isLimitedValue: boolean,
	) => {
    if (!isLimitedValue) return 'Digite o valor para emissão do boleto para depósito.';

    if (ValorMinimoPorTransacao && ValorMaximoPorTransacao)
      return `Insira um valor entre ${this.formatToCurrency(ValorMinimoPorTransacao)}/${this.formatToCurrency(ValorMaximoPorTransacao)} para emitirmos o boleto para depósito.`;

    return `Insira um valor de até ${this.formatToCurrency(ValorMaximoPorTransacao)} para emitirmos o boleto para depósito.`;
  };

	getLimitsDeposit() {
		this.preload(true);
		this.depositPerTicketService.getLimitsDeposit().subscribe( data => {

			if (data.isLimitedValue) {
				this.form.controls.value.setValidators([Validators.required, Validators.min(data.min), Validators.max(data.max)]);
			}
			this.form.controls.value.updateValueAndValidity();

			this.limitsDeposit = data;

			this.preload(false);

		}, error => {
			this.preload(false);
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{element: '[data-component="deposit-per-ticket"] .content', show: active, delay: delay});
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/deposit-per-ticket/deposit-data/deposit-data.component.ts